var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLogged)?_c('div',{attrs:{"id":"app"}},[_c('LayoutVue',[_c('RouterView')],1)],1):_c('img',{attrs:{"id":"logo","src":require("@/assets/img/logo.svg"),"alt":"Logo"}})
}
var staticRenderFns = []

export { render, staticRenderFns }